import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/work.jpeg'


const _hoisted_1 = { class: "row mb-5 mb-xl-10 mx-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "testimg",
  src: _imports_0,
  alt: "test",
  style: {}
}, null, -1)

import { ref, inject } from "vue";
import "../assets/css/style.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'RebateIB',
  setup(__props) {

const api = inject("api");
console.log(api);
const items = ref([]);
console.log(items);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.$t("tip.tbd")) + " ", 1),
    _hoisted_2
  ]))
}
}

})